import Network from 'infrastructure/js/modules/network';

export function fetchGridData(query) {
  return Network.post("materials/scrap", query);
}
